import { useEffect, useRef, useState } from "react";
import { decryptData, defaulUrl, fmt, impression } from "../components/const";
import Select from "react-select";
import UseFetch from "../components/UseFetch";
import Swal from "sweetalert2";
import EditePaieFacture from "../Ventes/EditePaieFacture";
import EditePaieDette from "../Clients/EditePaieDette";
import EditeAvance from "../Clients/EditeAvance";
import EditeVersement from "../Magasins/EditeVersement";
import EditeOpration from "../Magasins/EditeOperation";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const Caisse = () => {
    const [datejour, setDateJour] = useState((new Date()).toISOString().slice(0, 10));
    const [date1, setDate1] = useState(datejour);
    const [date2, setDate2] = useState(datejour);
    const profile = decryptData("user_profile");
    const [isLoading, setIsLoading] = useState(false);
    const user = decryptData("USER");
    const { data: magasins, isloading } = UseFetch('magasins/liste');
    const [rapport, setRapport] = useState(null);
    const [search, setSearch] = useState('');
    const [selectPaie, setSelectPaie] = useState(null);
    const [selectedMagasin, setSelectedMag] = useState(profile ? { "value": profile?.idmagasin, "label": profile?.magasin } : null);
    const printElement = useRef();

    const handleShow = () => {
        if (!selectedMagasin) {
            Swal.fire({
                title: "Erreur",
                text: "Veuillez choisir un magasin",
                icon: 'error'
            })
            return
        }
        setIsLoading(true);
        let status = 0;
        fetch(`${defaulUrl}rapport/magasin/${selectedMagasin?.value}/${date1}/${date2}`, {
            method: "GET",
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            }
        }).then((response) => {
            status = response.status;
            return response.json()
        }).then(da => {
            setIsLoading(false);
            if (status === 200) {
                setRapport(da);
                setSearch(''); // reset search when loading new rapport
            }
        }).catch(err => {
            setIsLoading(false);
            console.error(err);
        })
    }

    useEffect(() => {
        if (user.droit === 'Magasin') {
            handleShow();
        }
    }, [isloading]);

    // --- Helper: filtre générique ---
    const filterArray = (arr, keys = []) => {
        if (!arr) return [];
        if (!search || search.trim() === '') return arr;
        const q = search.toLowerCase().trim();
        return arr.filter(item =>
            keys.some(k => {
                const val = item?.[k];
                if (val === null || val === undefined) return false;
                return String(val).toLowerCase().includes(q);
            })
        );
    };

    // --- Données filtrées selon la recherche (pour l'affichage et les totaux) ---
    const filteredRapport = rapport ? {
        ...rapport,
        payes: filterArray(rapport.payes || [], ["numero", "client", "conteneur"]),
        ventes_site: filterArray(rapport.ventes_site || [], ["no_cmd", "client"]),
        remboursements: filterArray(rapport.remboursements || [], ["numero", "client", "conteneur"]),
        dettes: filterArray(rapport.dettes || [], ["client"]),
        avances: filterArray(rapport.avances || [], ["client"]),
        entrees: filterArray(rapport.entrees || [], ["description"]),
        sorties: filterArray(rapport.sorties || [], ["description"]),
        versements: filterArray(rapport.versements || [], ["status"]),
    } : null;

    // --- Totaux recalculés sur les données filtrées ---
    const totalPaye = filteredRapport?.payes?.reduce((prev, curr) => prev + (parseFloat(curr.montant) || 0), 0) || 0;
    const totalRemb = filteredRapport?.remboursements?.reduce((prev, curr) => prev + (parseFloat(curr.montant) || 0), 0) || 0;
    const totalCredit = filteredRapport?.dettes?.reduce((prev, curr) => prev + (parseFloat(curr.montant) || 0), 0) || 0;
    const totalAvance = filteredRapport?.avances?.reduce((prev, curr) => prev + (parseFloat(curr.montant) || 0), 0) || 0;
    const totalEntree = filteredRapport?.entrees?.reduce((prev, curr) => prev + (parseFloat(curr.montant) || 0), 0) || 0;
    const totalSortie = filteredRapport?.sorties?.reduce((prev, curr) => prev + (parseFloat(curr.montant) || 0), 0) || 0;
    const totalVersement = filteredRapport?.versements?.reduce((prev, curr) => prev + (parseFloat(curr.montant) || 0), 0) || 0;
    const totalPaieSite = filteredRapport?.ventes_site?.reduce((prev, curr) => prev + (parseFloat(curr.montant) || 0), 0) || 0;

    // --- Fonction pour exporter tout le rapport en PDF (reste sur les données complètes 'rapport') ---
    const exportRapportPDF = () => {
        if (!rapport) return;
        const doc = new jsPDF("l", "pt");
        const pageWidth = doc.internal.pageSize.getWidth();
        let startY = 20;
        // --- Ajouter le Bilan ---
        doc.setFontSize(16);
        doc.setTextColor(0, 0, 0);
        doc.text("BILAN", 20, startY);
        startY += 10;

        const bilanRows = [
            { label: "SOLDE INITIAL", value: fmt(rapport.solde_initial) },
            { label: "TOTAL ESPECE", value: fmt(rapport.payes?.reduce((a, b) => a + (parseFloat(b.montant) || 0), 0) || 0) },
            { label: "TOTAL REMB. FACT", value: fmt(rapport.remboursements?.reduce((a, b) => a + (parseFloat(b.montant) || 0), 0) || 0) },
            { label: "TOTAL REMB. DETTE INIT", value: fmt(rapport.dettes?.reduce((a, b) => a + (parseFloat(b.montant) || 0), 0) || 0) },
            { label: "TOTAL AVANCE CLT", value: fmt(rapport.avances?.reduce((a, b) => a + (parseFloat(b.montant) || 0), 0) || 0) },
            { label: "TOTAL ENTREE", value: fmt(rapport.entrees?.reduce((a, b) => a + (parseFloat(b.montant) || 0), 0) || 0) },
            { label: "TOTAL SORTIE", value: fmt(rapport.sorties?.reduce((a, b) => a + (parseFloat(b.montant) || 0), 0) || 0) },
            { label: "TOTAL VERSEMENT", value: fmt(rapport.versements?.reduce((a, b) => a + (parseFloat(b.montant) || 0), 0) || 0) },
            { label: "TOTAL ENCAISSEMENT SUR SITE", value: fmt(rapport?.total_paie_site) },
            { label: "SOLDE FINAL", value: fmt(rapport?.solde_final) }
        ];
        autoTable(doc, {
            startY,
            head: [["LIBELLE", "MONTANT"]],
            body: bilanRows.map(r => [r.label, r.value]),
            theme: "grid",
            styles: { fontSize: 10 },
            headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
        });

        startY = doc.lastAutoTable.finalY + 20;

        const addSection = (title, columns, rows) => {
            if (!rows || rows.length === 0) return;
            doc.setFontSize(14);
            doc.setTextColor(0, 0, 128);
            doc.text(title, 20, startY);
            startY += 10;

            autoTable(doc, {
                startY,
                head: [columns.map(c => c.header)],
                body: rows.map(r => columns.map(c => r[c.dataKey])),
                theme: "grid",
                styles: { fontSize: 9 },
                headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
                didDrawPage: () => {
                    const pageNumber = doc.internal.getNumberOfPages();
                    doc.setFontSize(8);
                    doc.text(`Page ${pageNumber}`, pageWidth - 40, doc.internal.pageSize.getHeight() - 10, { align: "right" });
                }
            });
            startY = doc.lastAutoTable.finalY + 20;
        };

        // --- Sections (sur les données complètes 'rapport') ---
        addSection("Ventes en espèces", [
            { header: "N°FACTURES", dataKey: "numero" },
            { header: "MONTANT", dataKey: "montant" },
            { header: "CLIENT", dataKey: "client" },
            { header: "CONTENEUR", dataKey: "conteneur" },
            { header: "DATE", dataKey: "created_at" }
        ], rapport?.payes?.map((p, i) => ({
            numero: p.numero, montant: p.montant?.toLocaleString() + " GNF", client: p.client, conteneur: p.conteneur, created_at: p.created_at
        })) || []);

        addSection("Paiement vente sur site", [
            { header: "N°FACTURES", dataKey: "no_cmd" },
            { header: "MONTANT", dataKey: "montant" },
            { header: "CLIENT", dataKey: "client" },
            { header: "DATE", dataKey: "created_at" }
        ], rapport?.ventes_site?.map((p, i) => ({
            no_cmd: p.no_cmd, montant: p.montant?.toLocaleString() + " GNF", client: p.client, created_at: p.created_at
        })) || []);

        addSection("Remboursements factures", [
            { header: "N°FACTURE", dataKey: "numero" },
            { header: "MONTANT", dataKey: "montant" },
            { header: "CLIENT", dataKey: "client" },
            { header: "CONTENEUR", dataKey: "conteneur" },
            { header: "DATE", dataKey: "created_at" }
        ], rapport?.remboursements?.map((r, i) => ({
            numero: r.numero, montant: r.montant?.toLocaleString() + " GNF", client: r.client, conteneur: r.conteneur, created_at: r.created_at
        })) || []);

        addSection("Remboursements dettes initiales", [
            { header: "CLIENT", dataKey: "client" },
            { header: "MONTANT", dataKey: "montant" },
            { header: "DATE", dataKey: "created_at" }
        ], rapport?.dettes?.map((r, i) => ({
            client: r.client, montant: r.montant?.toLocaleString() + " GNF", created_at: r.created_at
        })) || []);

        addSection("Versement avances client", [
            { header: "CLIENT", dataKey: "client" },
            { header: "MONTANT", dataKey: "montant" },
            { header: "DATE", dataKey: "created_at" }
        ], rapport?.avances?.map((r, i) => ({
            client: r.client, montant: r.montant?.toLocaleString() + " GNF", created_at: r.created_at
        })) || []);

        addSection("Entrées de caisse", [
            { header: "DESCRIPTION", dataKey: "description" },
            { header: "MONTANT", dataKey: "montant" },
            { header: "DATE", dataKey: "created_at" }
        ], rapport?.entrees?.map((r, i) => ({
            description: r.description, montant: r.montant?.toLocaleString() + " GNF", created_at: r.created_at
        })) || []);

        addSection("Sortie de caisse", [
            { header: "DESCRIPTION", dataKey: "description" },
            { header: "MONTANT", dataKey: "montant" },
            { header: "DATE", dataKey: "created_at" }
        ], rapport?.sorties?.map((r, i) => ({
            description: r.description, montant: r.montant?.toLocaleString() + " GNF", created_at: r.created_at
        })) || []);

        addSection("Versement à la Comptabilité", [
            { header: "MONTANT", dataKey: "montant" },
            { header: "STATUT", dataKey: "status" },
            { header: "DATE", dataKey: "created_at" }
        ], rapport?.versements?.map((r, i) => ({
            montant: r.montant?.toLocaleString() + " GNF", status: r.status, created_at: r.created_at
        })) || []);

        doc.save(`Rapport_Magasin_${selectedMagasin?.label || 'Tous'}.pdf`);
    };

    return (
        <div className="caisse">
            {isLoading && <div className="loader"></div>}
            <div className="row align-items-center">
                <div className="h2 col-lg-4" >RAPPORT MAGASIN</div>
                <div className="col-lg-8 modal-footer">
                    {(user.droit !== "Magasin") &&
                        <div className="col-lg-3">
                            <Select className="w-100"
                                value={selectedMagasin ? { label: selectedMagasin?.label, value: selectedMagasin?.value } : null}
                                options={magasins?.map(mag => ({ value: `${mag.id}`, label: `${mag.mag}` }))}
                                onChange={setSelectedMag}
                                placeholder='choisir un magasin'
                            />
                        </div>
                    }
                    <input type="date" className="form-control w-auto m-1" value={date1} onChange={e => setDate1(e.target.value)} />
                    <input type="date" className="form-control w-auto m-1" value={date2} onChange={e => setDate2(e.target.value)} />
                    <button className="btn btn-primary m-1" onClick={handleShow}><i className="bx bx-search"></i></button>

                    <button className="btn btn-success m-1" onClick={exportRapportPDF}><i className="bx bx-file"></i> Export PDF</button>
                </div>
            </div>

            {selectedMagasin ? <div className="container" ref={printElement}>
                <input type="search" placeholder="Rechercher..." className="form-control my-2" value={search} onChange={(e) => setSearch(e.target.value)} />

                <div className="row my-1 row-cols-lg-5 row-cols-md-3 row-cols-1 g-2">
                    <div className="col">
                        <div className="card p-1 h-100 ">
                            <div className="small fw-bold text-secondary text-center"> SOLDE INITIAL</div>
                            <div className="small fw-bold text-center">{parseFloat(rapport?.solde_initial || 0).toLocaleString()} GNF</div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="card p-1 h-100 ">
                            <div className="small fw-bold text-secondary text-center">TOTAL ESPECE</div>
                            <div className="small fw-bold text-center">{totalPaye?.toLocaleString()} GNF</div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="card p-1 h-100 ">
                            <div className="small fw-bold text-secondary text-center">TOTAL REMB. FACT</div>
                            <div className="small fw-bold text-center">{totalRemb?.toLocaleString()} GNF</div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="card p-1 h-100 ">
                            <div className="small fw-bold text-secondary text-center">TOTAL REMB. DETTE INIT</div>
                            <div className="small fw-bold text-center">{totalCredit?.toLocaleString()} GNF</div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="card p-1 h-100 ">
                            <div className="small fw-bold text-secondary text-center">TOTAL AVANCE CLT</div>
                            <div className="small fw-bold text-center">{totalAvance?.toLocaleString()} GNF</div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="card p-1 h-100 ">
                            <div className="small fw-bold text-secondary text-center">TOTAL ENTREE</div>
                            <div className="small fw-bold text-center">{totalEntree?.toLocaleString()} GNF</div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="card p-1 h-100 bg-danger-subtle">
                            <div className="small fw-bold text-secondary text-center">TOTAL VERSEMENT</div>
                            <div className="small fw-bold text-center">{totalVersement?.toLocaleString()} GNF</div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="card p-1 h-100 bg-danger-subtle">
                            <div className="small fw-bold text-secondary text-center">TOTAL SORTIE</div>
                            <div className="small fw-bold text-center">{totalSortie?.toLocaleString()} GNF</div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="card p-1 h-100">
                            <div className="small fw-bold text-secondary text-center">TOTAL ENCAISSEMENT SUR SITE</div>
                            <div className="small fw-bold text-center">{totalPaieSite?.toLocaleString()} GNF</div>
                        </div>
                    </div>

                    <div className="col">
                        <div className="card p-1 h-100">
                            <div className="small fw-bold text-secondary text-center">SOLDE</div>
                            <div className="small fw-bold text-center">{(rapport?.solde_final || 0).toLocaleString()} GNF</div>
                        </div>
                    </div>
                </div>

                <hr />
                <div className="table-responsive mt-2">
                    {(filteredRapport?.payes?.length > 0) && <>
                        <h4 className="mt-2">Ventes en espèces</h4>
                        <table className="table table-bordered table-stripped my-2">
                            <thead className="table-success">
                                <tr>
                                    <th>N°FACTURES</th>
                                    <th>MONTANT</th>
                                    <th>CLIENT</th>
                                    <th>CONTENEUR</th>
                                    <th>DATE</th>
                                    {user.droit === "Magasin" && <th className="text-end">ACTION</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filteredRapport.payes.map((paie, ind) => (
                                        <tr key={ind}>
                                            <td>{paie.numero}</td>
                                            <td>{paie.montant?.toLocaleString()} GNF</td>
                                            <td>{paie.client}</td>
                                            <td>{paie.conteneur}</td>
                                            <td>{paie.created_at}</td>
                                            {user.droit === "Magasin" && <td className="text-end">
                                                {paie.duree < 2 && <button className="btn btn-primary" data-bs-toggle='modal' data-bs-target='#editePaie' onClick={() => setSelectPaie(paie)}>
                                                    <i className="bx bx-edit"></i>
                                                </button>
                                                }
                                            </td>}
                                        </tr>
                                    ))
                                }
                                <tr className="bg-secondary-subtle fw-bold ">
                                    <td>TOTAL</td>
                                    <td>{totalPaye?.toLocaleString()} GNF</td>
                                </tr>
                            </tbody>
                        </table>
                    </>}
                    {/* Paiement site */}
                    {(filteredRapport?.ventes_site?.length > 0) && <>
                        <h4 className="mt-2">Paiement vente sur site</h4>
                        <table className="table table-bordered table-stripped my-2">
                            <thead className="table-success">
                                <tr>
                                    <th>N°FACTURES</th>
                                    <th>MONTANT</th>
                                    <th>CLIENT</th>
                                    <th>DATE</th>
                                    {user.droit === "Magasin" && <th className="text-end">ACTION</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filteredRapport.ventes_site.map((paie, ind) => (
                                        <tr key={ind}>
                                            <td>{paie.no_cmd}</td>
                                            <td>{paie.montant?.toLocaleString()} GNF</td>
                                            <td>{paie.client}</td>
                                            <td>{paie.created_at}</td>
                                            {user.droit === "Magasin" && <td className="text-end">
                                                {paie.duree < 2 && <button className="btn btn-primary" data-bs-toggle='modal' data-bs-target='#editePaie' onClick={() => setSelectPaie(paie)}>
                                                    <i className="bx bx-edit"></i>
                                                </button>
                                                }
                                            </td>}
                                        </tr>
                                    ))
                                }
                                <tr className="bg-secondary-subtle fw-bold ">
                                    <td>TOTAL</td>
                                    <td>{totalPaieSite?.toLocaleString()} GNF</td>
                                </tr>
                            </tbody>
                        </table>
                    </>}
                    {/* Remboursements factures */}
                    {(filteredRapport?.remboursements?.length > 0) && <>
                        <h4 className="mt-2">Remboursements factures</h4>
                        <table className="table table-bordered table-stripped my-2">
                            <thead className="table-success">
                                <tr>
                                    <th>N°FACTURES</th>
                                    <th>MONTANT</th>
                                    <th>CLIENT</th>
                                    <th>CONTENEUR</th>
                                    <th>DATE</th>
                                    {user.droit === "Magasin" && <th className="text-end">ACTION</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filteredRapport.remboursements.map((remb, ind) => (
                                        <tr key={ind}>
                                            <td>{remb.numero}</td>
                                            <td>{remb.montant?.toLocaleString()} GNF</td>
                                            <td>{remb.client}</td>
                                            <td>{remb.conteneur}</td>
                                            <td>{remb.created_at}</td>
                                            {user.droit === "Magasin" && <td className="text-end">
                                                {remb.duree < 2 && <button className="btn btn-primary" data-bs-toggle='modal' data-bs-target='#editePaie' onClick={() => setSelectPaie(remb)}>
                                                    <i className="bx bx-edit"></i>
                                                </button>
                                                }
                                            </td>}
                                        </tr>
                                    ))
                                }
                                <tr className="bg-secondary-subtle fw-bold ">
                                    <td>TOTAL</td>
                                    <td>{totalRemb?.toLocaleString()} GNF</td>
                                </tr>
                            </tbody>
                        </table>
                    </>}
                    {/* Dettes */}
                    {(filteredRapport?.dettes?.length > 0) && <>
                        <h4 className="mt-2">Remboursements dettes initiales</h4>
                        <table className="table table-bordered table-stripped my-2">
                            <thead className="table-success">
                                <tr>
                                    <th>CLIENT</th>
                                    <th>MONTANT</th>
                                    <th>DATE</th>
                                    {user.droit === "Magasin" && <th className="text-end">ACTION</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filteredRapport.dettes.map((remb, ind) => (
                                        <tr key={ind}>
                                            <td>{remb.client}</td>
                                            <td>{remb.montant?.toLocaleString()} GNF</td>
                                            <td>{remb.created_at}</td>
                                            {user.droit === "Magasin" && <td className="text-end">
                                                {remb.duree < 2 && <button className="btn btn-primary" data-bs-toggle='modal' data-bs-target='#editePaieDette' onClick={() => setSelectPaie(remb)}>
                                                    <i className="bx bx-edit"></i>
                                                </button>
                                                }
                                            </td>}
                                        </tr>
                                    ))
                                }
                                <tr className="bg-secondary-subtle fw-bold ">
                                    <td>TOTAL</td>
                                    <td>{totalCredit?.toLocaleString()} GNF</td>
                                </tr>
                            </tbody>
                        </table>
                    </>}
                    {/* Avances */}
                    {(filteredRapport?.avances?.length > 0) && <>
                        <h4 className="mt-2">Versement avances client</h4>
                        <table className="table table-bordered table-stripped my-2">
                            <thead className="table-success">
                                <tr>
                                    <th>CLIENT</th>
                                    <th>MONTANT</th>
                                    <th>DATE</th>
                                    {user.droit === "Magasin" && <th className="text-end">ACTION</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filteredRapport.avances.map((av, ind) => (
                                        <tr key={ind}>
                                            <td>{av.client}</td>
                                            <td>{av.montant?.toLocaleString()} GNF</td>
                                            <td>{av.created_at}</td>
                                            {user.droit === "Magasin" && <td className="text-end">
                                                {av.duree < 2 && <button className="btn btn-primary" data-bs-toggle='modal' data-bs-target='#editeAvance' onClick={() => setSelectPaie(av)}>
                                                    <i className="bx bx-edit"></i>
                                                </button>
                                                }
                                            </td>}
                                        </tr>
                                    ))
                                }
                                <tr className="bg-secondary-subtle fw-bold ">
                                    <td>TOTAL</td>
                                    <td>{totalAvance?.toLocaleString()} GNF</td>
                                </tr>
                            </tbody>
                        </table>
                    </>}
                    {/* Entrees */}
                    {(filteredRapport?.entrees?.length > 0) && <>
                        <h4 className="mt-2">Entrées de caisse</h4>
                        <table className="table table-bordered table-stripped my-2">
                            <thead className="table-success">
                                <tr>
                                    <th>DESCRIPTION</th>
                                    <th>MONTANT</th>
                                    <th>DATE</th>
                                    {user.droit === "Magasin" && <th className="text-end">ACTION</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filteredRapport.entrees.map((ent, ind) => (
                                        <tr key={ind}>
                                            <td>{ent.description}</td>
                                            <td>{ent.montant?.toLocaleString()} GNF</td>
                                            <td>{ent.created_at}</td>
                                            {user.droit === "Magasin" && <td className="text-end">
                                                {ent.duree < 2 && <button className="btn btn-primary" data-bs-toggle='modal' data-bs-target='#editeOperation' onClick={() => setSelectPaie(ent)}>
                                                    <i className="bx bx-edit"></i>
                                                </button>
                                                }
                                            </td>}
                                        </tr>
                                    ))
                                }
                                <tr className="bg-secondary-subtle fw-bold ">
                                    <td>TOTAL</td>
                                    <td>{totalEntree?.toLocaleString()} GNF</td>
                                </tr>
                            </tbody>
                        </table>
                    </>}
                </div>

                <div className="table-responsive mt-2">
                    {(filteredRapport?.versements?.length > 0) && <>
                        <h4 className="mt-2">Versement à la Comptabilité</h4>
                        <table className="table table-bordered table-stripped my-2">
                            <thead className="table-danger">
                                <tr>
                                    <th>MONTANT</th>
                                    <th>STATUT</th>
                                    <th>DATE</th>
                                    {user.droit === "Magasin" && <th className="text-end">ACTION</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filteredRapport.versements.map((vers, ind) => (
                                        <tr key={ind}>
                                            <td>{vers.montant?.toLocaleString()} GNF</td>
                                            <td>{vers.status}</td>
                                            <td>{vers.created_at}</td>
                                            {(user.droit === "Magasin" && vers.status !== "confirmé") && <td className="text-end">
                                                {vers.duree < 2 && <button className="btn btn-primary" data-bs-toggle='modal' data-bs-target='#editeVers' onClick={() => setSelectPaie(vers)}>
                                                    <i className="bx bx-edit"></i>
                                                </button>
                                                }
                                            </td>}
                                        </tr>
                                    ))
                                }
                                <tr className="bg-secondary-subtle fw-bold ">
                                    <td>TOTAL</td>
                                    <td>{totalVersement?.toLocaleString()} GNF</td>
                                </tr>
                            </tbody>
                        </table>
                    </>}
                    {(filteredRapport?.sorties?.length > 0) && <>
                        <h4 className="mt-2">Sortie de caisse</h4>
                        <table className="table table-bordered table-stripped my-2">
                            <thead className="table-danger">
                                <tr>
                                    <th>DECRIPTION</th>
                                    <th>MONTANT</th>
                                    <th>DATE</th>
                                    {user.droit === "Magasin" && <th className="text-end">ACTION</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filteredRapport.sorties.map((sortie, ind) => (
                                        <tr key={ind}>
                                            <td>{sortie.description}</td>
                                            <td>{sortie.montant?.toLocaleString()} GNF</td>
                                            <td>{sortie.created_at}</td>
                                            {user.droit === "Magasin" && <td className="text-end">
                                                {sortie.duree < 2 && <button className="btn btn-primary" data-bs-toggle='modal' data-bs-target='#editeOperation' onClick={() => setSelectPaie(sortie)}>
                                                    <i className="bx bx-edit"></i>
                                                </button>
                                                }
                                            </td>}
                                        </tr>
                                    ))
                                }
                                <tr className="bg-secondary-subtle fw-bold ">
                                    <td>TOTAL</td>
                                    <td>{totalSortie?.toLocaleString()} GNF</td>
                                </tr>
                            </tbody>
                        </table>
                    </>}
                </div>
            </div> : <div className="p-3 h5 text-center text-primary">CHOISISSEZ UN MAGASIN</div>}

            <EditePaieFacture paie={selectPaie} />
            <EditePaieDette paie={selectPaie} />
            <EditeAvance paie={selectPaie} />
            <EditeVersement paie={selectPaie} />
            <EditeOpration paie={selectPaie} />
        </div>
    );
}

export default Caisse;
